// const BaseUrl = "http://localhost:8080";
// const BaseUrl = "https://gjskillb.hkcl.net";
const BaseUrl = "https://gjuskillcoursesb.hkcl.in";
export default BaseUrl;